<app-side-panel-shell
  [useMobileView]="useMobileView"
  [isOpened]="menuIsOpened"
  [header]="menuHeader"
  [hideContentOverflow]="menuContent === menuContentTypes.Tags"
  [contentTemplate]="panelContent"
  (closePanel)="closeMenu.emit()">
</app-side-panel-shell>

<ng-template #panelContent>
  @if (emailId && menuContent === menuContentTypes.Notes) {
    <div class="h-full w-full">
      <app-email-note-list
        [emailId]="emailId"
        (refreshNotes)="refreshNotes.emit($event)"></app-email-note-list>
    </div>
  }

  @if (emailId && menuContent === menuContentTypes.Templates) {
    <div class="h-full w-full">
      <app-email-templates
        (templateSelected)="templateSelected.emit($event)"
        [mailAccountId]="mailAccountId"></app-email-templates>
    </div>
  }

  @if (emailId && menuContent === menuContentTypes.Audit) {
    <div class="h-full w-full">
      <app-email-audit [emailId]="emailId"></app-email-audit>
    </div>
  }

  @if (emailId && menuContent === menuContentTypes.Notifications) {
    <div class="h-full">
      <app-email-notifications-dialog
        [emailId]="emailId"
        (openEmailDetails)="
          openEmailDetails.emit($event)
        "></app-email-notifications-dialog>
    </div>
  }

  @if (emailId && menuContent === menuContentTypes.Tags) {
    <app-email-add-tags-dialog
      [emailsForTags]="{
        mailAccountId: mailAccountId,
        ids: [emailId],
        emails: [emailDetails],
      }"
      [isDrawer]="false"
      (submitEventEmitter)="createTag.emit($event)"></app-email-add-tags-dialog>
  }
</ng-template>
